import { render, staticRenderFns } from "./authVisit.vue?vue&type=template&id=5c674c2d&scoped=true&"
import script from "./authVisit.vue?vue&type=script&lang=js&"
export * from "./authVisit.vue?vue&type=script&lang=js&"
import style0 from "./authVisit.vue?vue&type=style&index=0&id=5c674c2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c674c2d",
  null
  
)

export default component.exports